export default __webpack_public_path__ + "static/media/GSB.a2e4d44a.png";